











import {DeviceViewModel} from "@/components/portfolio/DeviceViewModel";

export default {
  name: "DeviceView",
  props: {
    device: {
      type: Object as () => DeviceViewModel,
      required: true,
    }
  },
  data: function (): object {
    return {};
  }
}
